import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editEventService, type EditEventPayload, type EditEventResponse } from "../services/editEventService";

export function useEditEvent() {
  const queryClient = useQueryClient();

  return useMutation<EditEventResponse, Error, { keypointId: string | number; payload: EditEventPayload }>({
    mutationFn: ({ keypointId, payload }) => editEventService(keypointId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["events-by-month"] });// Refetch events
      queryClient.invalidateQueries({ queryKey: ["retail-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["wholesale-events-by-month"] });
      queryClient.invalidateQueries({ queryKey: ["ecom-events-by-month"] });
    },
  });
}